module.exports = __webpack_public_path__ + "static/media/LandingPage2.5822ba42.jpg";